import { URL } from '../../constants/insurance/constant';
import { _axios } from '../../plugins/axios';
export const getCallTypes = () => {

    let config = {
      method: 'post',
      url: URL.providercore_url + "insurance/callTypeLookUp"//'https://api-plus.medibuddy.in/MediMarketLookUp/calltype.json',
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);
  }  
  
  
  export const getCallStatuses = () => {
  
    let config = {
      method: 'get',
      url: 'https://api-plus.medibuddy.in/MediMarketLookUp/callstatus.json',
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);
  }

  export const addCorrespondence = (data) => {
    let config = {
        method: 'post',
        url: URL.providercore_url + 'insurance/addCorrespondence',
        headers: {
            accesstoken: JSON.parse(localStorage.getItem("access_token")),
          },
        data : data
      };
    
      return _axios(config)
        .then((response) => response.data)
        .catch((error) => error);
  }

  export const showCorrespondence = (id) => {
  
    let config = {
      method: 'post',
      url: URL.providercore_url + "insurance/showCorrespondence", //"https://ch-api-procheck.medibuddy.in/GetCorrespondence/153/"+id+"/0/",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
      },
      data:{
        id:id
      }
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);

  }

  export const communicationHistory = (id) => {
    let obj = {
      moduleName: "Request",
      requestId: id
    }
  
    let config = {
      method: 'post',
      url: URL.providercore_url + "insurance/communicationHistory",  // 'https://ch-api-procheck.medibuddy.in/communicationHistory',
      headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
        },
      data : obj
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);

  }

  export const getDownloadEmail = (id) => {
    return URL.providercore_url + 'insurance/getDownloadEmail?id=' + id
  }

  export const resendMailSms =(data)=>{
    const config ={ 
      url : URL.providercore_url + 'insurance/resendMailSMS',
      method:'post',
      headers: {
        contentType: "application/json; charset=utf-8",
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
      },
      data:{
          "contractId": 9782,
          ...data,
      }
    }
    return _axios(config)
      .then(res=> res.data)
      .catch(error=> error)
  }